var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94663 12.8934C2.45797 12.4047 2.45855 11.6123 2.94793 11.1243L5.12374 8.95491C5.61185 8.46823 6.40181 8.46852 6.88956 8.95556L9.06217 11.125C9.55068 11.6128 9.55126 12.4042 9.06346 12.8928L6.89085 15.0685C6.4028 15.5573 5.61085 15.5576 5.12244 15.0692L2.94663 12.8934Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9512 12.8928C14.4634 12.4042 14.464 11.6128 14.9525 11.125L17.1251 8.95556C17.6129 8.46852 18.4028 8.46823 18.8909 8.95491L21.0668 11.1243C21.5561 11.6123 21.5567 12.4047 21.0681 12.8934L18.8922 15.0692C18.4038 15.5576 17.6119 15.5573 17.1238 15.0685L14.9512 12.8928Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1234 14.9593C11.6116 14.4712 12.4031 14.4712 12.8912 14.9593L15.0628 17.1309C15.5509 17.619 15.5509 18.4105 15.0628 18.8987L12.8912 21.0702C12.4031 21.5584 11.6116 21.5584 11.1234 21.0702L8.95187 18.8987C8.46371 18.4105 8.46371 17.619 8.95187 17.1309L11.1234 14.9593Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1221 2.95003C11.6106 2.46013 12.4041 2.46013 12.8925 2.95003L15.0662 5.13011C15.5531 5.61847 15.5525 6.40892 15.0649 6.89657L12.8912 9.07023C12.4031 9.55838 11.6116 9.55838 11.1234 9.07023L8.94978 6.89657C8.46214 6.40892 8.46155 5.61847 8.94848 5.13011L11.1221 2.95003Z",
    stroke: "#4E4B66",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.6a771666.svg";
export { ForwardRef as ReactComponent };